// errorRoute.js
'use strict';

/**
 * Error route
 */
const errorRoute = message => {
  let status;

  try {
    status = JSON.parse(message || '')?.status;
  } catch (_) {
    // ignore
  }

  if (status === 404) return { path: '/404', status };
  if (status === 403) return { path: '/403', status };

  return { path: '/error', status };
};

export default errorRoute;
